
custom.gtmDatalayer = (() => {

  // push events to data layer for GTM
  function gtmPush(data) {
    const dataLayer = window.dataLayer || [];
  	if(typeof dataLayer !== 'undefined') {
  		if(!data.event) data.event = 'GAEvent';
  		dataLayer.push(data)
  	} else {
    	//console.log(data)
  	}
  }
  function gtmPushElem(elem) {
  	const data = {
      eventCategory: elem.data('category'),
      eventAction: elem.data('action'),
      eventLabel: elem.data('label')
    }
  	gtmPush(data);
  }

  // fix string to make spaces dashes and all lowercase
  function vanitizeString(input) {
  	if(typeof input === 'string') {
  		return (input.toLowerCase()).replace(/ /g,'-')
  	}
  	return input
  }

  return {
    gtmPush,
    gtmPushElem,
    vanitizeString
  }

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/gtm-datalayer.js